<template>
  <div class="kachel-badge" :class="colorClass">
    {{ label }}
  </div>
</template>

<script>
import configPriority from '@/core/produkte/reisen/priority.config.json';

// Mapping der Bootstrap-Variante aus der Priority-Config auf die Kachel-Farbklasse
const variantToColor = {
  success: 'green',
  warning: 'yellow',
  danger: 'red',
  secondary: 'gray',
};

// Rendert die Reise-Priorität (0-3) als farbige Kachel
export default {
  props: {
    prioritaet: { type: [Number, String], default: null },
  },
  computed: {
    // Config-Eintrag zur übergebenen Priorität; null bei ungültigem Wert
    configEntry() {
      if (this.prioritaet === null || this.prioritaet === undefined || isNaN(this.prioritaet)) return null;
      return configPriority[this.prioritaet] ?? null;
    },
    label() {
      return this.configEntry?.value ?? '-';
    },
    colorClass() {
      return variantToColor[this.configEntry?.color] ?? 'gray';
    },
  },
};
</script>
